import {
  Divider,
  Options,
  Container,
  SelectMenu,
  SelectButton,
  CheckDivider,
  materialTheme,
  SelectSubItem,
  SubItemsWrapper,
  SubItemsContainer,
} from "./styles";
import React, { Fragment } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import { useTheme } from "@/services/zustand/theme";
import { ThemeProvider } from "@mui/material/styles";
import { MiniWhiteArrow } from "../svg/MiniWhiteArrow";
import { capitalizeString } from '@/utils/captalizeWords';
import { parseToSnakeCase } from '@/utils/parseToSnakCase';
import FormControlLabel from "@mui/material/FormControlLabel";
import { useFilterClassification } from "@/hooks/useClassification";
import { SmallArrow } from "@/components/global/svgs/plans/smallArrow";

export const SelectFilters: React.FC = () => {
  const theme = useTheme((state) => state.theme);

  const {
    checkedAll,
    filterItems,
    filterValues,
    checkboxItems,
    handleCheckedAll,
    checkboxSubItems,
    handleFilterChange,
    checkboxSubItemsClicked,
    setCheckboxSubItemsClicked,
    handleChangeOneByOneCheckBoxItem,
    handleChangeOneByOneCheckBoxSubItem,
  } = useFilterClassification();

  return (
    <ThemeProvider theme={materialTheme}>
      <Container>
        {Object.entries(filterItems).map(([key, _]) => (
          <SelectMenu key={key} as='div' isOpen={filterValues[key]}>
            <SelectButton
              onClick={(e) => {
                handleFilterChange({ e });
              }}
            >
              <p className="resizeable-accessibility">
                {capitalizeString(key)}
              </p>
              <MiniWhiteArrow theme={theme} isOpen={filterValues[key]} />
            </SelectButton>
            <Options className="option_items">
              <FormControlLabel
                label="Selecionar todos"
                control={
                  <Checkbox
                    checked={checkedAll[key]}
                    onChange={(e) =>
                      handleCheckedAll(
                        e.target.checked,
                        key
                      )
                    }
                    color={theme === "light" ? "primary" : "secondary"}
                  />
                }
              />
              <FormGroup sx={{ marginLeft: "1rem" }}>
                {checkboxItems[key]?.map((item: any) => {
                  const subtemas = item?.subtemas as any[];
                  return (
                    <Fragment key={item?.id}>
                      <FormControlLabel
                        value={item?.id}
                        label={item?.descricao || item?.nome}
                        control={
                          <Checkbox
                            checked={item?.checked}
                            color={theme === "light" ? "primary" : "secondary"}
                            onChange={({ target }) => {
                              handleChangeOneByOneCheckBoxItem(
                                target.value,
                                target.checked,
                                key,
                              );
                            }}
                          />
                        }
                      />
                      {subtemas?.length > 0 && (
                        <SubItemsContainer key={item?.id}>
                          <SubItemsWrapper isOpen={checkboxSubItemsClicked[parseToSnakeCase(item?.descricao)]}>
                            <SelectSubItem>
                              <CheckDivider clicked={checkboxSubItemsClicked[parseToSnakeCase(item?.descricao)]}/>
                              <SmallArrow
                                isClicked={checkboxSubItemsClicked[parseToSnakeCase(item?.descricao)]}
                                onClick={() => {
                                  setCheckboxSubItemsClicked((prev: any) => ({
                                    ...prev,
                                    [parseToSnakeCase(item?.descricao)]: !checkboxSubItemsClicked[parseToSnakeCase(item?.descricao)],
                                  }));
                                }}
                              />
                            </SelectSubItem>
                            <Options className="option_subitems">
                              {checkboxSubItems[parseToSnakeCase(item?.descricao)]?.map((subitem: any) => {
                                return (
                                  <FormControlLabel
                                    key={subitem?.id}
                                    value={subitem?.id}
                                    label={capitalizeString(subitem?.descricao) || capitalizeString(subitem?.nome)}
                                    control={
                                      <Checkbox
                                        checked={subitem?.checked}
                                        onChange={({ target }) =>
                                          handleChangeOneByOneCheckBoxSubItem(
                                            target.value,
                                            target.checked,
                                            parseToSnakeCase(item?.descricao) || parseToSnakeCase(item?.nome)
                                          )
                                        }
                                        color={
                                          theme === "light"
                                            ? "primary"
                                            : "secondary"
                                        }
                                      />
                                    }
                                  />
                                );
                                })}
                            </Options>
                          </SubItemsWrapper>
                        </SubItemsContainer>
                      )}
                    </Fragment>
                  );
                })}
              </FormGroup>
              <Divider />
            </Options>
          </SelectMenu>
        ))}
      </Container>
    </ThemeProvider>
  );
};
